import { formatCurrency, transformDateToLocalDateString } from "helpers";
import { InvoiceIncomingEditFormValues } from "services/api/finance/incoming-invoices/types";

/**
 * Vrijednosti obrasca po ključevima koje poslužitelj koristi za položaje na dokumentu. Služe oznaci
 * na hover: uz mjesto na računu piše i što je s njega završilo u obrascu.
 */
export const buildInvoiceFieldValues = (
  formValues: InvoiceIncomingEditFormValues
): Record<string, string> => {
  const amount = (value: number | null) => (value == null ? "" : formatCurrency.format(value));
  const date = (value: Date | null) => transformDateToLocalDateString(value) ?? "";

  return {
    supplier_name: formValues.supplierName ?? "",
    supplier_oib: formValues.supplierOIB ?? "",
    invoice_number: formValues.invoiceNumber ?? "",
    invoice_date: date(formValues.invoiceDate),
    due_date: date(formValues.dueDate),
    total: amount(formValues.total),
    total_without_tax: amount(formValues.totalWithoutTax),
    total_tax: amount(formValues.totalTax),
  };
};
